import React, { useCallback } from 'react';
import { showExamBoard } from '@src/settings/search';
import { hasRefinement } from '@src/utils/search';
import { useCurrentRefinements, useSearchBox } from 'react-instantsearch';

export const useShowMoreInformation = () => {
  const currentFilters = useCurrentRefinements();
  const { query } = useSearchBox();

  const hasSelectedExamCourse = currentFilters.items.some((item) =>
    item.attribute.includes('doc_exam_course'),
  );

  const hasSelectedExamBoard = currentFilters.items.some((item) =>
    item.attribute.includes('doc_exam_board'),
  );

  const showExamBoardFilter = hasRefinement(currentFilters.items, 'doc_exam_course', showExamBoard);

  return (
    Boolean(query) || (hasSelectedExamCourse && (showExamBoardFilter ? hasSelectedExamBoard : true))
  );
};

export const useSortByPracticeType = () =>
  useCallback((a: any, b: any) => {
    const aHasMarkScheme = a.name.toLowerCase().includes('mark scheme');
    const bHasMarkScheme = b.name.toLowerCase().includes('mark scheme');

    if (aHasMarkScheme !== bHasMarkScheme) {
      return aHasMarkScheme ? 1 : -1;
    }

    return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
  }, []);

export const useSortByModules = () =>
  useCallback((a: any, b: any) => {
    const aHasOld = a.name.toLowerCase().includes('old');
    const bHasOld = b.name.toLowerCase().includes('old');

    if (aHasOld !== bHasOld) {
      return aHasOld ? 1 : -1;
    }

    return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
  }, []);
